import type { CSSProperties, HTMLAttributes } from 'react';
import './progress-bar.css';

export type ProgressBarProps = HTMLAttributes<HTMLDivElement> & {
  value: number;
  label?: string;
};

export function ProgressBar({ value, label, className, ...props }: ProgressBarProps) {
  const normalized = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
  const style = { '--hopper-progress-value': `${normalized}%` } as CSSProperties;

  return (
    <div
      {...props}
      className={['hopper-progress', className].filter(Boolean).join(' ')}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(normalized)}
      aria-label={label}
    >
      <span className="hopper-progress__bar" style={style}>
        <span className="hopper-progress__fill" />
      </span>
    </div>
  );
}
